module.exports = __webpack_public_path__ + "static/media/dyyy.1fb73dc6.mp4";